import React, { useState } from 'react';
import './../calendar.css';
import BookItemsModel from '../components/client_dashboard/appointments/bookItemsModel';

function MonthCalendarDays(props) {
    console.log(props.changeViewMode)
    const [showModal, setShowModal] = useState(false);

    const [modalContent, setModalContent] = useState("");

    const firstDayOfMonth = new Date(props.day.getFullYear(), props.day.getMonth(), 1);
    const weekdayOfFirstDay = firstDayOfMonth.getDay();
    let currentDays = [];

    for (let day = 0; day < 42; day++) {
        if (day === 0 && weekdayOfFirstDay === 0) {
            firstDayOfMonth.setDate(firstDayOfMonth.getDate() - 7);
        } else if (day === 0) {
            firstDayOfMonth.setDate(firstDayOfMonth.getDate() + (day - weekdayOfFirstDay));
        } else {
            firstDayOfMonth.setDate(firstDayOfMonth.getDate() + 1);
        }

        let calendarDay = {
            currentMonth: (firstDayOfMonth.getMonth() === props.day.getMonth()),
            date: (new Date(firstDayOfMonth)),
            month: firstDayOfMonth.getMonth(),
            number: firstDayOfMonth.getDate(),
            selected: (firstDayOfMonth.toDateString() === props.day.toDateString()),
            year: firstDayOfMonth.getFullYear(),
            appointments: props.appointments.filter(slot => {
                const bookedTime = new Date(slot.book_date);
                return bookedTime.getDate() === firstDayOfMonth.getDate() && bookedTime.getMonth() === firstDayOfMonth.getMonth() && bookedTime.getFullYear() === firstDayOfMonth.getFullYear();
            })
        }

        currentDays.push(calendarDay);
    }

    const openModal = (content) => {
        console.log(content);
        setShowModal(true);
        setModalContent(content);
    }
    const closeModal = () => {

        setShowModal(false);
        setModalContent(() => "");
    };
    return (
        <div className="table-content">
            {
                currentDays.map((day) => {
                    return (
                        <div className={"calendar-day p-1" + (day.currentMonth ? " current" : "") + (day.selected ? " selected" : "")}
                            onClick={() => props.changeCurrentDay(day)}>
                            <div className="d-flex  flex-column">
                                <p className="align-self-end mb-2">{day.number}</p>
                                <ul>
                                    {day.appointments.length > 0 ? (
                                        <>
                                            {day.appointments.slice(0, props.maxVisibleItems).map((slot, index) => (
                                                <li key={index} className="booked-time" onClick={() => openModal(slot)}>
                                                    <p>{slot.book_time}</p>
                                                    <p>{slot.firstName}</p>
                                                </li>
                                            ))}
                                            {day.appointments.length > props.maxVisibleItems ? (
                                                <li className="more" onClick={() => props.changeViewMode('day')}>
                                                    <p>+ {day.appointments.length - props.maxVisibleItems} more</p>
                                                </li>
                                            ) : null}
                                        </>
                                    ) : null}
                                </ul>

                            </div>

                        </div>
                    )
                })
            }
            <BookItemsModel show={showModal}
                handleClose={closeModal} title="Booking Details"
                content={modalContent} />
        </div>
    )
}

export default MonthCalendarDays;